// This mixin contains code that is used for both gas and electricity meters
import moment from 'moment';
import _filters from '@/mixins/filters'

export default {
  mixins: [_filters],
  methods: {
    // configs(meter) {
    //   return this.$_.sortBy(meter.MeterConfigs, "EffectiveFrom").reverse();
    // },
  },
  computed: {
    meters() {
      if (this.$store.state.meters.activeService) {
        return this.$store.state.meters.activeService.Meters.slice().reverse();
      }
    },
    // User active selection properties 
    activeService() {
      return this.$store.state.meters.activeService;
    },
    activeMeterInfo() {
      if (!this.$store.state.meters.activeMeterInfo) {
        this.$store.dispatch("changeActiveMeterInfo", this.currentMeter);
      }
      return this.$store.state.meters.activeMeterInfo;
    },
    activeConfigInfo() {
      if (!this.$store.state.meters.activeConfigInfo) {
        this.$store.dispatch("changeActiveConfigInfo", this.currentConfig);
      }
      return this.$store.state.meters.activeConfigInfo;
    },
    activeMeterPointConfig() {
      /* It looks stupid because it is, but meter point configs ETDs are inclusive, meter configs ETDs are exlusive
      and there isn't any data at the time of writing that will work with EFDs as all of the meter config EFDs are several
      years before the earliest meter point config EFD. So it is written to use the EFDs but that will return an undefined
      on all current (as of time of writing) data; it will then use the ETDs of the meter config minus one day, as that ETD
      is exclusive and the ETD of the meter point config that it is being compared to isn't, meaning that when they are the
      same they aren't the same, so minus one day to correct that. 
      
      tl;dr
      The first attempt to return an active meter point is how it should work, the second is a fallback to deal with the 
      data that's currently in the test environments. */

      let meterConfig = this.activeConfigInfo;
      let that = this
      let activeMeterPointConfig = function(date) {
        return that.$_.find(
          that.activeService.MeterPoint.MeterPointConfigs,
          (meterPointConfig) => {
            // When there is no "EffectiveTo" property it automatically uses the current date because JavaScript. :|
            return moment(date).isBetween(
              meterPointConfig.EffectiveFrom,
              meterPointConfig.EffectiveTo,
              "days",
              "[]"
            );
          }
        )}
      // Return first non falsy value.
      return activeMeterPointConfig(meterConfig.EffectiveFrom) || activeMeterPointConfig(moment(meterConfig.EffectiveTo).subtract(1, 'days'))
    },
  }
}